
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { ISenffLinkCard } from '@/interfaces/senffProposal';
import { IInvoiceAlunoView } from '@/interfaces/invoiceAluno';
import DateComponent from '@/components/DateComponent.vue';
import { senffProposalStore } from '@/store';

@Component({
  components: {
    DateComponent,
  },
})
export default class LinkCard extends Vue {
  @Prop({ type: Boolean, required: true }) readonly showDialog!: boolean;
  //id da tabela senff_proposal
  @Prop({ type: String, default: null }) readonly proposal_id: string;
  @Prop({ type: Object, default: null })
  readonly invoice_aluno: IInvoiceAlunoView;
  @Prop({ type: Number, default: null }) readonly senff_proposal_id: number;
  @Prop({ type: String, default: null }) readonly cnpj: string;

  link_card = {
    token: null,
    password: null,
    numLinking: null,
    birthDate: null,
  };

  isOpen: boolean = false;
  isLoading: boolean = false;
  isHidden: boolean = true;

  @Watch('showDialog')
  onShowDialogChanged(newValue: boolean) {
    this.isOpen = newValue;
  }

  @Watch('isOpen')
  onInternalDialogChanged(newValue: boolean) {
    if (!newValue) {
      this.link_card = {
        token: null,
        password: null,
        numLinking: null,
        birthDate: null,
      };
      this.isHidden = true;
    }

    this.$emit('update:showDialog', newValue);
  }

  closeDialog() {
    this.isOpen = false;
  }

  get linkCardFields() {
    return [
      {
        name: 'token',
        type: 'text',
        label: 'Token',
        rules: [(v) => !!v || 'Campo obrigatório'],
      },
      {
        name: 'birthDate',
        type: 'date',
        label: 'Data de nascimento',
        rules: [(v) => !!v || 'Campo obrigatório'],
      },
      {
        name: 'numLinking',
        type: 'text',
        label: 'Código de vinculação',
        rules: [(v) => !!v || 'Campo obrigatório'],
      },
    ];
  }

  removeLeadingZeros(code: string): string {
    return code.replace(/^0+/, '');
  }

  async submitLinkCard() {
    let form: any = this.$refs.formLinkCard;
    if (!form.validate()) {
      return;
    }

    this.isLoading = true;

    let numLinking = this.removeLeadingZeros(this.link_card.numLinking);

    let payload: ISenffLinkCard = {
      cpf: this.invoice_aluno.cpf,
      resendTokenPlatform: 'SMS',
      proposal_id: this.proposal_id,
      birthDate: this.link_card.birthDate,
      token: this.link_card.token,
      numLinking: numLinking,
    };

    const response = await senffProposalStore.submitSenffLinkCard({
      senff_link_card: payload,
      senff_proposal_id: this.senff_proposal_id,
    });

    if (response.confirmed) {
      this.link_card = {
        token: null,
        password: null,
        numLinking: null,
        birthDate: null,
      };
      this.isLoading = false;
      this.closeDialog();
    }

    this.isLoading = false;
  }

  async mounted() {}
}
